import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import RequestSettingsTabs from "./RequestSettingsTabs";
export default function RequestDetails() {
  return (
    <Box>
      {/* Tabs */}
      <RequestSettingsTabs />

      {/* Tab Content */}
      <Outlet />
    </Box>
  );
}
